// EXPL: LinkedIn permalinks carry the post id in one of two shapes:
//   /posts/<user>_<slug>-activity-<id>-<code>
//   /feed/update/urn:li:<type>:<id>
// The embed endpoint takes a full urn, so preserve the type when the url states it
// and fall back to `activity` for the /posts/ slug form.
const LINKEDIN_URN_PATTERN = /urn:li:(activity|share|ugcPost):(\d+)|-activity-(\d+)/

export function extractLinkedInUrn(url: string): string | undefined {
  const match = LINKEDIN_URN_PATTERN.exec(url || '')

  if (!match) {
    return undefined
  }

  const [, urnType, urnId, activityId] = match

  return urnId ? `urn:li:${urnType}:${urnId}` : `urn:li:activity:${activityId}`
}
